import * as signalR from "@microsoft/signalr";

export function createGameHub(baseUrl: string) {
  return new signalR.HubConnectionBuilder()
    .withUrl(`${baseUrl}/hubs/game`, {
      withCredentials: true,
    })
    .withAutomaticReconnect()
    .build();
}
